export function sortParties(promo, order) {
  const clonedPromo = JSON.parse(JSON.stringify(promo));
  const property = order.name;
  clonedPromo.sort((a, b) => {
    const newA = a[property] || '';
    const newB = b[property] || '';
    return order.up ? newA.localeCompare(b) : newB.localeCompare(a);
  });
  return clonedPromo;
}
